import type { BuilderSlide, SlideHotspot } from "../types"

/** First slide in builder order (Preview matches the downloaded PPTX). */
export function firstLinearIndex(slides: BuilderSlide[]): number {
  return coerceLinearStartIndex(slides, 0)
}

export function lastLinearIndex(slides: BuilderSlide[]): number {
  return slides.length > 0 ? slides.length - 1 : 0
}

export function nextLinearIndex(slides: BuilderSlide[], from: number): number {
  if (slides.length === 0) return from
  return Math.min(from + 1, slides.length - 1)
}

export function prevLinearIndex(slides: BuilderSlide[], from: number): number {
  if (slides.length === 0) return from
  return Math.max(from - 1, 0)
}

export function coerceLinearStartIndex(slides: BuilderSlide[], requested: number): number {
  if (slides.length === 0) return 0
  return Math.max(0, Math.min(requested, slides.length - 1))
}

export function builderIndexForDeckSlide(
  slides: BuilderSlide[],
  deckId: string,
  targetIndex: number
): number | null {
  const found = slides.findIndex(
    (item) => item.slide.deck_id === deckId && item.slide.slide_index === targetIndex
  )
  return found >= 0 ? found : null
}

export function resolveHotspotJump(
  slides: BuilderSlide[],
  hotspot: SlideHotspot,
  nav: { currentIndex: number; lastViewedIndex: number | null }
): number | null {
  switch (hotspot.kind) {
    case "last_viewed":
      if (nav.lastViewedIndex === null) return null
      if (nav.lastViewedIndex < 0 || nav.lastViewedIndex >= slides.length) return null
      return nav.lastViewedIndex
    case "slide": {
      const current = slides.at(nav.currentIndex)
      if (!current) return null
      return builderIndexForDeckSlide(slides, current.slide.deck_id, hotspot.target_index)
    }
    default: {
      const _exhaustive: never = hotspot
      return _exhaustive
    }
  }
}
